module.exports = __webpack_public_path__ + "static/assets/f25bfdd392bfe67ed3b03050083ccc28.svg";